import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import NoYappingSPA from './NoYappingSPA';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <NoYappingSPA />
  </React.StrictMode>
);
